import { Badge, Card, Col, Row, Space, Typography } from "antd";
import dayjs from "dayjs";
import React from "react";
import InlineEditableCustomerCode from "./InlineEditableCustomerCode";
import {
  QUOTE_STATUS_DISPLAY,
  QUOTE_STATUSES_MAP,
} from "../../../shared/constants";

const { Text, Title } = Typography;

function formatSubmittedAt(data) {
  return data?.submitted_at
    ? dayjs(data.submitted_at).format("MMM D, YYYY")
    : "-";
}

const ApplicationHeaderBar = ({
  data,
  actions,
  extended = false,
  isRenewal = false,
  onCustomerCodeSave,
}) => {
  const parts = [data?.year && String(data.year), data?.make, data?.model]
    .filter(Boolean)
    .join(" ");
  const aircraftSummary = parts
    ? `${parts} ${data?.registration ? `(${data.registration})` : ""}`.trim()
    : data?.registration
    ? `(${data.registration})`
    : "-";

  const meta = {
    status: data?.status ?? "In Progress",
    submittedAt: formatSubmittedAt(data),
    lastEdited: data?.last_updated_at
      ? `${dayjs(data.last_updated_at).format("MMM D, YYYY")}
          ${data?.last_updated_by ? " • " + data?.last_updated_by : ""}`
      : "—",
    customerCode: data?.customer_code ?? "", // keep empty so component shows "None"
  };

  return (
    <>
      <Row align="middle" justify="space-between" style={{ marginBottom: 8 }}>
        <Col>
          <Space direction="vertical" size={0}>
            <Title level={5} style={{ margin: 0 }}>
              {data?.main_owner_name || "—"}
            </Title>

            <Text type="secondary">
              {aircraftSummary}
              {!isRenewal ? ` - Received on ${formatSubmittedAt(data)}` : ""}
            </Text>
          </Space>
        </Col>
        <Col>
          <Space size={8} wrap>
            {(actions || []).map((btn, i) => (
              <React.Fragment key={i}>{btn}</React.Fragment>
            ))}
          </Space>
        </Col>
      </Row>

      {extended && (
        <Card
          size="small"
          style={{ marginBottom: 12, background: "#fafafa" }}
          bodyStyle={{ padding: 8 }}
        >
          <Row gutter={[16, 8]} align="middle">
            <Col xs={24} md={8}>
              <Space size={6}>
                <Text type="secondary" style={{ fontSize: 15 }}>
                  Status:
                </Text>
                <Badge
                  status={QUOTE_STATUSES_MAP[meta.status] || "processing"}
                  text={
                    <Text strong style={{ fontSize: 15 }}>
                      {QUOTE_STATUS_DISPLAY[meta.status] || meta.status}
                    </Text>
                  }
                />
              </Space>
            </Col>

            <Col xs={24} md={8}>
              <Text type="secondary" style={{ fontSize: 15 }}>
                Last edited:
              </Text>{" "}
              <Text>{meta.lastEdited}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary" style={{ fontSize: 15 }}>
                Customer code:
              </Text>{" "}
              <InlineEditableCustomerCode
                value={meta.customerCode}
                onSave={onCustomerCodeSave}
              />
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};

export default ApplicationHeaderBar;
